import { render, staticRenderFns } from "./TableViewColumnPicker.vue?vue&type=template&id=8bfb5344&scoped=true&"
import script from "./TableViewColumnPicker.vue?vue&type=script&lang=js&"
export * from "./TableViewColumnPicker.vue?vue&type=script&lang=js&"
import style0 from "./TableViewColumnPicker.vue?vue&type=style&index=0&id=8bfb5344&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bfb5344",
  null
  
)

export default component.exports